import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";

const api = new APICore();

export const generateModelImage = createAsyncThunk(
  "model/generateModelImage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.GENERATE_MODEL_IMAGE, data);
      showSuccess(response.data.message);
      return response.data.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addNewModel = createAsyncThunk(
  "model/addNewModel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.ADD_NEW_MODEL, data);
      showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getMyModel = createAsyncThunk(
  "model/getMyModel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(Url.GET_MY_MODEL, data);
      return response.data.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getMyModelDetails = createAsyncThunk(
  "model/getMyModelDetails",
  async (modelId, { rejectWithValue }) => {
    try {
      const response = await api.get(`${Url.GET_MY_MODEL_DETAILS}?modelId=${modelId}`);
      return response.data.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getModelAnalytics = createAsyncThunk(
  "model/getModelAnalytics",
  async (modelId, { rejectWithValue }) => {
    try {
      const response = await api.get(`${Url.GET_MY_MODEL_ANALYTICS}?modelId=${modelId}`);
      return response.data.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createModelImages = createAsyncThunk(
  "model/createModelImages",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.GENERATE_MODEL_IMAGE, data);
      showSuccess(response.data.message);
      return response.data.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createModelVideos = createAsyncThunk(
  "model/createModelVideos",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.GENERATE_MODEL_IMAGE, data);
      showSuccess(response.data.message);
      return response.data.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAutoGeneratedMedia = createAsyncThunk(
  "model/getAutoGeneratedMedia",
  async (influencerId, { rejectWithValue }) => {
    try {
      const response = await api.get(`${Url.AUTO_GENERATED_MEDIA}?influencerId=${influencerId}`);
      return response.data;
    } catch (error) {
      showError(error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);